import { NgModule } from '@angular/core';
import { addNavMenuItem, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem(
            {
                id: 'landing-page',
                label: 'Landing pages',
                routerLink: ['/extensions/landing-pages'],
                icon: 'checkbox-list',
                requiresPermission: (userPermissions) =>
                    userPermissions.includes('UpdateShoppingList'),
            },
            'marketing'
        ),
    ],
})
export class LandingPageNavModule {}
